/**
 * Battlepass Stats Api
 * Здесь содержатся основные запросы для работы со статистикой
 */

import MinigamesApi from "@libs/api/MinigamesApi";

class Stats extends MinigamesApi {
  constructor() {
    super();
    this.setBaseUrl("/minigames/battlepass/"); // пишем сюда наш базовый URL к API, от которого будут формироваться остальные URLы
  }

  getStatsData() {
    return this.get("stat");
  }
}

export default Stats;
